import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'nl2br' })
export class Nl2brPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return (value as string).replace(/\r\n|\n\r|\r|\n/g, '<br/>');
  }
}